<template>
    <div id="cart-step-4-body" class="cart-step-body">
        <div class="group-profile">
            <div class="group-left">
                <h2 class="cart-title">
                    {{ __('Alap adatok') }}
                </h2>

                <div class="group-row">
                    <label
                        for="checkout_name"
                        class="label-required"
                    >
                        {{ __('Név') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_name"
                        v-model="data.name"
                        type="text"
                        autocomplete="name"
                        :class="{'is-invalid': errors && errors['name']}"
                        class="form-control"
                    >
                    <form-error
                        field="name"
                        :errors="errors"
                    />
                </div>

                <div class="group-row">
                    <label
                        for="checkout_email"
                        class="label-required"
                    >
                        {{ __('E-mail') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_email"
                        v-model="data.email"
                        type="email"
                        autocomplete="email"
                        class="form-control"
                        :class="{'is-invalid': errors && errors['email']}"
                    >
                    <form-error
                        field="email"
                        :errors="errors"
                    />
                </div>


                <div class="group-row flex phone-number-row phone-number-row-anonym">
                    <label
                        for="checkout_phone_number"
                        class="label-required flex"
                    >
                        {{ __('Telefonszám') }}
                        <sup>*</sup>
                    </label>
                    <phone-number-field
                        class="form-control"
                        :fix-country-code="checkoutData.phoneNumberFixCountryCode"
                        :country-code="data.phone_number['country_code']"
                        :default-country-id="data.same_as_billing ? data.billing_country_id : data.shipping_country_id"
                        :prefix="data.phone_number.prefix"
                        :line-number="data.phone_number['line_number']"
                        :errors="errors"
                        @input="setPhoneNumber($event)"
                    />
                </div>

                <small id="phone-help-text" class="form-text text-muted">
                    {{ __('Telefonszám formátuma +36301234567') }}
                </small>

            </div>

            <div class="group-right">
                <h2 class="cart-title">
                    {{ __('Számlázási adatok') }}
                </h2>

                <div class="group-row">
                    <label
                        for="checkout_billing_name"
                        class="label-required"
                    >
                        {{ __('Név/Cégnév') }}
                    </label>
                    <input
                        id="checkout_billing_name"
                        v-model="data.billing_name"
                        type="text"
                        autocomplete="billing_name"
                        class="form-control"
                        :class="{'is-invalid': errors && errors['billing_name']}"
                    >
                    <form-error
                        field="billing_name"
                        :errors="errors"
                    />
                </div>

                <div class="group-row">
                    <label
                        for="billing_country_id"
                        class="label-required"
                    >
                        {{ __('Ország') }}
                        <sup>*</sup>
                    </label>
                    <select v-model="data.billing_country_id"
                            id="billing_country_id">
                        <option
                            v-for="country in checkoutData.countries"
                            :key="country.id"
                            :value="country.id"
                            :selected="isSelectedBillingCountry(data, country)"
                        >
                            {{ country.name }}
                        </option>
                    </select>

                    <form-error
                        field="billing_country_id"
                        :errors="errors"
                    />
                </div>


                <div class="group-row">
                    <label
                        for="checkout_billing_city"
                        class="label-required"
                    >
                        {{ __('Város') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_billing_city"
                        v-model="data.billing_city"
                        type="text"
                        autocomplete="billing_city"
                        class="form-control"
                        :class="{'is-invalid': errors && errors['billing_city']}"
                    >
                    <form-error
                        field="billing_city"
                        :errors="errors"
                    />
                </div>

                <div class="group-row col-md">
                    <label
                        for="checkout_billing_address"
                        class="label-required"
                    >
                        {{ __('Utca/Út/Tér STB.') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_billing_address"
                        v-model="data.billing_address"
                        type="text"
                        autocomplete="billing_address"
                        :class="{'is-invalid': errors && errors['billing_address']}"
                        class="form-control"
                    >
                    <form-error
                        field="billing_address"
                        :errors="errors"
                    />
                </div>
                <div class="group-row col-md">
                    <label
                        for="checkout_billing_house_number"
                        class="label-required"
                    >
                        {{ __('Házszám') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_billing_house_number"
                        v-model="data.billing_house_number"
                        type="text"
                        autocomplete="billing_house_number"
                        :class="{'is-invalid': errors && errors['billing_house_number']}"
                        class="form-control"
                    >
                    <form-error
                        field="billing_house_number"
                        :errors="errors"
                    />
                </div>

                <div class="group-row">
                    <label
                        for="checkout_billing_zip"
                        class="label-required"
                    >
                        {{ __('Irányítószám') }}
                        <sup>*</sup>
                    </label>
                    <input
                        id="checkout_billing_zip"
                        v-model="data.billing_zip"
                        type="text"
                        autocomplete="billing_zip"
                        class="form-control"
                        :class="{'is-invalid': errors && errors['billing_zip']}"
                    >
                    <form-error
                        field="billing_zip"
                        :errors="errors"
                    />
                </div>

                <div v-if="showVatNumber" class="group-row">
                    <label for="checkout_vat_number">{{ __('Adószám') }}</label>
                    <input
                        id="checkout_vat_number"
                        v-model="data.vat_number"
                        type="text"
                        autocomplete="vat_number"
                        class="form-control"
                        :class="{'is-invalid': errors && errors['vat_number']}"
                    >
                    <form-error
                        field="vat_number"
                        :errors="errors"
                    />
                </div>
                <small v-if="showVatNumber" id="vat-help-text" class="form-text text-muted">
                    {{ __('Az adószám formátuma 12345678-1-12') }}
                </small>
            </div>
        </div>
        <div id="collectpoint_1">
            <div class="group-right">
                <div
                    v-if="shippable && !selectedShippingModeHasPickupPoints"
                    class="shipping-data"
                >
                    <h3 class="title">{{ __('Szállítási adatok') }}</h3>

                    <div class="group-row">
                        <div class="form-check">
                            <input
                                id="checkout_same_as_billing"
                                v-model="data.same_as_billing"
                                type="checkbox"
                                name="same_as_billing"
                                value="1"
                                class="form-check-input"
                            >
                            <label
                                class="form-check-label"
                                for="checkout_same_as_billing"
                            >
                                {{ __('Megegyezik a számlázási adatokkal') }}
                            </label>
                        </div>
                    </div>

                    <div v-show="data.same_as_billing === false" class="group-profile">
                        <div class="group-row">
                            <label
                                for="checkout_shipping_name"
                                class="label-required"
                            >
                                {{ __('Név/Cégnév') }}
                                <sup>*</sup>
                            </label>
                            <input
                                id="checkout_shipping_name"
                                v-model="data.shipping_name"
                                type="text"
                                autocomplete="shipping_name"
                                class="form-control"
                                :class="{'is-invalid': errors && errors['shipping_name']}"
                            >
                            <form-error
                                field="shipping_name"
                                :errors="errors"
                            />
                        </div>

                        <div class="group-row">
                            <label
                                for="checkout_billing_name"
                                class="label-required"
                            >
                                {{ __('Ország') }}
                                <sup>*</sup>
                            </label>
                            <select v-model="data.shipping_country_id">
                                <option
                                    v-for="country in checkoutData.countries"
                                    :key="country.id"
                                    :value="country.id"
                                    :selected="isSelectedShippingCountry(data, country)"
                                >
                                    {{ country.name }}
                                </option>
                            </select>

                            <form-error
                                field="shipping_country_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="group-row">
                            <label
                                for="checkout_shipping_city"
                                class="label-required"
                            >
                                {{ __('Város') }}
                                <sup>*</sup>
                            </label>
                            <input
                                id="checkout_shipping_city"
                                v-model="data.shipping_city"
                                type="text"
                                autocomplete="shipping_city"
                                class="form-control"
                                :class="{'is-invalid': errors && errors['shipping_city']}"
                            >
                            <form-error
                                field="shipping_city"
                                :errors="errors"
                            />
                        </div>

                        <div class="group-row col-md">
                            <label
                                for="checkout_shipping_address"
                                class="label-required"
                            >
                                {{ __('Utca/Út/Tér STB.') }}
                                <sup>*</sup>
                            </label>
                            <input
                                id="checkout_shipping_address"
                                v-model="data.shipping_address"
                                type="text"
                                autocomplete="shipping_address"
                                :class="{'is-invalid': errors && errors['shipping_address']}"
                                class="form-control"
                            >
                            <form-error
                                field="shipping_address"
                                :errors="errors"
                            />
                        </div>
                        <div class="group-row col-md">
                            <label
                                for="checkout_shipping_house_number"
                                class="label-required"
                            >
                                {{ __('Házszám') }}
                                <sup>*</sup>
                            </label>
                            <input
                                id="checkout_shipping_house_number"
                                v-model="data.shipping_house_number"
                                type="text"
                                autocomplete="shipping_house_number"
                                :class="{'is-invalid': errors && errors['shipping_house_number']}"
                                class="form-control"
                            >
                            <form-error
                                field="shipping_house_number"
                                :errors="errors"
                            />
                        </div>
                        <div class="group-row">
                            <label
                                for="checkout_shipping_zip"
                                class="label-required"
                            >
                                {{ __('Irányítószám') }}
                                <sup>*</sup>
                            </label>
                            <input
                                id="checkout_shipping_zip"
                                v-model="data.shipping_zip"
                                type="text"
                                autocomplete="shipping_zip"
                                class="form-control"
                                :class="{'is-invalid': errors && errors['shipping_zip']}"
                            >
                            <form-error
                                field="shipping_zip"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form-error
            field="internationalShipping"
            :errors="errors"
        />
    </div>
</template>

<script>
import guestCustomerDataBase from '../mixins/checkout/guestCustomerDataBase'

export default {
    name: 'GuestCustomerDataForm',
    mixins: [guestCustomerDataBase],

    data() {
        return {
            cities: [],
            billingPostalCode: null,
            billingCity: null,
            shippingCity: null,
            shippingPostalCode: null,
            selectedCountry: null,
        }
    },

    computed: {
        showVatNumber() {
            const index = this.checkoutData.countries.findIndex(c => c.id === this.data.billing_country_id);

            if (index !== -1 && this.checkoutData.countries[index].code == 'HU') {
                return true
            }

            return false
        },
    },

    methods: {
        isSelectedShippingCountry(data, country) {
            if (!data.shipping_country_id) {
                data.shipping_country_id = country.id
            }

            return data.shipping_country_id === country.id
        },

        isSelectedBillingCountry(data, country) {
            if (!data.billing_country_id) {
                data.billing_country_id = country.id
            }

            return data.billing_country_id === country.id
        }
    }
}
</script>
